import React, { useEffect, useState } from 'react';
import { getWalletDetailsFromOrderId } from '../../services/api/get-pharmacy-orders';

const BRAND = '#6C5DD3';
const BRAND_LIGHT = '#F5F4FF';
const BRAND_BORDER = '#E5E9FE';
const TEXT_MUTED = '#A5A6BB';
const TEXT_SECONDARY = '#585969';
const BORDER = '#E3E3E3';

function UserWallet({ propOrderId, isStarHealthUser, starPolicyNo }) {
  const [orderId, setOrderId] = useState(null);
  const [PharmacyTotalBalance, setPharmacyTotalBalance] = useState(null);
  const [PharmacyTotalRemainingBalance, setPharmacyTotalRemainingBalance] = useState(null);
  const [PharmacyCiTotalBalance, setPharmacyCiTotalBalance] = useState(null);
  const [PharmacyCiTotalRemainingBalance, setPharmacyCiTotalRemainingBalance] = useState(null);

  useEffect(() => { setOrderId(propOrderId); }, [propOrderId]);

  useEffect(() => {
    if (orderId !== null) {
      getWalletDetailsFromOrderId(orderId).then((response) => {
        const details = response.body;
        setPharmacyTotalBalance(details.PharmacyTotalBalance);
        setPharmacyTotalRemainingBalance(details.PharmacyTotalBalanceRemaining);
        setPharmacyCiTotalBalance(details.PharmacyCiTotalBalance);
        setPharmacyCiTotalRemainingBalance(details.PharmacyCiTotalBalanceRemaining);
      });
    }
  }, [orderId]);

  const walletItems = [
    { label: 'Pharmacy Total Balance', value: PharmacyTotalBalance, icon: '💊' },
    { label: 'Pharmacy Remaining Balance', value: PharmacyTotalRemainingBalance, icon: '🔄' },
    { label: 'CI Total Balance', value: PharmacyCiTotalBalance, icon: '🏥' },
    { label: 'CI Remaining Balance', value: PharmacyCiTotalRemainingBalance, icon: '📊' },
  ];

  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
        {walletItems.map(({ label, value, icon }) => (
          <div key={label} style={{ flex: '1', minWidth: '150px', background: BRAND_LIGHT, border: `1px solid ${BRAND_BORDER}`, borderRadius: '6px', padding: '12px 16px' }}>
            <div style={{ fontSize: '18px', marginBottom: '4px' }}>{icon}</div>
            <div style={{ fontSize: '11px', color: TEXT_MUTED, fontWeight: 500, marginBottom: '4px' }}>{label}</div>
            <div style={{ fontSize: '20px', fontWeight: 700, color: BRAND }}>
              {value != null ? `₹${value}` : <span style={{ fontSize: '14px', color: TEXT_MUTED }}>—</span>}
            </div>
          </div>
        ))}

        {isStarHealthUser && (
          <div style={{ flex: '1', minWidth: '150px', background: '#FFFBF0', border: '1px solid #FFE2AC', borderRadius: '6px', padding: '12px 16px' }}>
            <div style={{ fontSize: '18px', marginBottom: '4px' }}>⭐</div>
            <div style={{ fontSize: '11px', color: TEXT_MUTED, fontWeight: 500, marginBottom: '4px' }}>Star Health Policy No.</div>
            <div style={{ fontSize: '15px', fontWeight: 700, color: '#B07800' }}>{starPolicyNo || '—'}</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserWallet;
